import AuthorizedRoute from "base-shell/lib/components/AuthorizedRoute";
import React, { lazy } from "react";
import UnauthorizedRoute from "base-shell/lib/components/UnauthorizedRoute";

const SignIn = lazy(() => import("rmw-shell/lib/pages/SignIn/SignIn"));
const MyAccount = lazy(() => import("rmw-shell/lib/pages/MyAccount/MyAccount"));
const Users = lazy(() => import("rmw-shell/lib/pages/Users"));
const User = lazy(() => import("rmw-shell/lib/pages/Users/User"));
const Roles = lazy(() => import("rmw-shell/lib/pages/Roles"));
const Role = lazy(() => import("rmw-shell/lib/pages/Roles/Role"));
const EditMembers = lazy(() => import("rmw-shell/lib/pages/EditMembers"));
const PageNotFound = lazy(() => import("../pages/PageNotFound"));

const getDefaultRoutes = (appConfig) => {
  return [
    {
      path: "/signin",
      exact: true,
      element: (
        <UnauthorizedRoute>
          <SignIn redirectTo={appConfig?.auth?.redirectTo || "/"} />
        </UnauthorizedRoute>
      ),
    },

    {
      path: "/edit_members/:uid",
      exact: true,
      element: (
        <AuthorizedRoute>
          <EditMembers />
        </AuthorizedRoute>
      ),
    },

    {
      path: "/roles",
      exact: true,
      element: (
        <AuthorizedRoute>
          <Roles />
        </AuthorizedRoute>
      ),
    },
    {
      path: "/create_role",
      exact: true,
      element: (
        <AuthorizedRoute>
          <Role />
        </AuthorizedRoute>
      ),
    },
    {
      path: "/roles/:uid",
      exact: true,
      element: (
        <AuthorizedRoute>
          <Role />
        </AuthorizedRoute>
      ),
    },
    {
      path: "/roles/:uid/:tab",
      exact: true,
      element: (
        <AuthorizedRoute>
          <Role />
        </AuthorizedRoute>
      ),
    },
    {
      path: "/my_account",
      exact: true,
      element: (
        <AuthorizedRoute>
          <MyAccount />
        </AuthorizedRoute>
      ),
    },
    {
      path: "/users",
      exact: true,
      element: (
        <AuthorizedRoute>
          <Users />
        </AuthorizedRoute>
      ),
    },
    {
      path: "/users/:uid",
      exact: true,
      element: (
        <AuthorizedRoute>
          <User />
        </AuthorizedRoute>
      ),
    },
    {
      path: "/users/:uid/:tab",
      exact: true,
      element: (
        <AuthorizedRoute>
          <User />
        </AuthorizedRoute>
      ),
    },
    {
      path: "*",
      element: (
        <AuthorizedRoute>
          <PageNotFound />
        </AuthorizedRoute>
      ),
    },
  ];
};

export { getDefaultRoutes };
